import {ReactNode} from 'react';
import {useTranslation} from 'react-i18next';
import {
  SkeletonCard,
  SkeletonImage,
  SkeletonContent,
  SkeletonLine,
  SkeletonButtonRow,
  SkeletonButton,
} from 'components/upselling/EnhanceYourStay/styled';
import {
  DealsContainer,
  DealsStatusBanner,
  SpinningLoader,
  DealsHeader,
  DealsTitle,
  DealsSubtitle,
  CompactCardStack,
} from './styled';

type Props = {
  registrationMessage?: string | ReactNode;
};

export function DealsLoadingState({registrationMessage}: Props) {
  const {t} = useTranslation();

  return (
    <DealsContainer>
      <DealsStatusBanner $isComplete={false}>
        <SpinningLoader size={16} />
        <span>{registrationMessage}</span>
      </DealsStatusBanner>
      <DealsHeader>
        <DealsTitle>{t('enhance_your_stay.title')}</DealsTitle>
        <DealsSubtitle>{t('enhance_your_stay.loading')}</DealsSubtitle>
      </DealsHeader>
      <CompactCardStack>
        {Array.from({length: 3})
          .map((_, index) => (
            <SkeletonCard key={index} $stackIndex={index}>
              <SkeletonImage />
              <SkeletonContent>
                <SkeletonLine $width="70%" $height="18px" />
                <SkeletonLine $width="100%" />
                <SkeletonLine $width="85%" />
                <SkeletonButtonRow>
                  <SkeletonButton />
                  <SkeletonButton />
                </SkeletonButtonRow>
              </SkeletonContent>
            </SkeletonCard>
          ))
          .reverse()}
      </CompactCardStack>
    </DealsContainer>
  );
}
